import { defineComponent as n, createBlock as a, openBlock as r, unref as l, mergeProps as p, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconDownload",
  __name: "IconDownload",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (r(), a(l(s), p(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", { d: "m15.47 12.47-2.72 2.72V4a.75.75 0 0 0-1.5 0v11.19l-2.72-2.72a.75.75 0 0 0-1.06 1.06l3.646 3.647a1.25 1.25 0 0 0 1.768 0l3.646-3.647a.75.75 0 1 0-1.06-1.06M6 19.25a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5H6" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
